/* eslint-env browser */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AUToastComponent from '@aarhus-university/au-lib-react-components/src/components/delphinus/AUToastComponent';
import PasswordForgetComponent from './PasswordForgotComponent';
import ChangePasswordComponent from './ChangePasswordComponent';
import actionCreators from '../actions/password';

const PasswordWrapperComponent = ({
  password: { saving, saved, validToken },
  context,
  messages,
  sendMail,
  patchPasswordAnonymous,
  dismissMessages,
  checkUserTokenIsValid,
  getContext,
}) => {
  useEffect(() => {
    dismissMessages();
  }, []);

  const renderMessages = messages.filter((x) => x.type === 'LdapPasswordChangeException').map(
    (message) => (
      <AUToastComponent
        key={message.message}
        message={{
          message: message.message,
          type: 'warning',
        }}
        dismiss={dismissMessages}
      />
    ),
  );

  return [
    <Router key="router">
      <Route
        path={`/${window.appLang}/password/forgot`}
        exact
        render={() => (
          <PasswordForgetComponent
            saving={saving}
            saved={saved}
            sendMail={sendMail}
          />
        )}
      />
      <Route
        path={`/${window.appLang}/password/new`}
        exact
        render={() => (
          <ChangePasswordComponent
            saving={saving}
            saved={saved}
            validToken={validToken}
            context={context}
            patchPassword={patchPasswordAnonymous}
            checkUserTokenIsValid={checkUserTokenIsValid}
            getContext={getContext}
            dismissMessages={dismissMessages}
            messages={messages.filter((x) => x.type === 'LdapPasswordUsedBeforeException')}
          />
        )}
      />
    </Router>,
    ReactDOM.createPortal(
      renderMessages,
      document.querySelector('body'),
      'messages',
    ),
  ];
};

PasswordWrapperComponent.displayName = 'PasswordWrapperComponent';

PasswordWrapperComponent.propTypes = {
  password: PropTypes.shape({}).isRequired,
  context: PropTypes.shape({}).isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  })).isRequired,
  patchPasswordAnonymous: PropTypes.func.isRequired,
  sendMail: PropTypes.func.isRequired,
  dismissMessages: PropTypes.func.isRequired,
  checkUserTokenIsValid: PropTypes.func.isRequired,
  getContext: PropTypes.func.isRequired,
};

export default connect(
  (state) => state.password,
  (dispatch) => bindActionCreators(actionCreators, dispatch),
)(PasswordWrapperComponent);
